<script setup lang="ts">
import HumidityIcon from '../../icons/HumidityIcon.vue';

const props = defineProps({
  value: {
    type: Number,
    required: true,
  },
});
</script>

<template>
  <div class="flex flex-row items-center w-full h-full justify-center">
    <HumidityIcon class="h-9" />
    <div class="ml-3 text-foreground text-2xl md:text-3xl font-light">
      {{ props.value }}%
    </div>
  </div>
</template>
